import {
  useQuery,
  UseQueryOptions,
  UseQueryResult,
} from "@tanstack/react-query";
import { PROPERTY_CATEGORY } from "./apiRoutes";
import axiosAuth from "@/services/axiosAuth";

interface UseGetProps {
  communityId: string
  queryParams?: Omit<UseQueryOptions, "queryKey">
}

const getActivePropertyCategories = async (communityId: string) =>
  await axiosAuth.get(`${PROPERTY_CATEGORY(communityId)}/active`);

const useGetActivePropertyCategories = ({communityId, queryParams}: UseGetProps): UseQueryResult<any> => {
  return useQuery({
    queryKey: ["property-active-categories", communityId],
    queryFn: () => getActivePropertyCategories(communityId),
    select: (data: any) => data.data,
    refetchOnWindowFocus: false,
    ...queryParams,
  });
};

export default useGetActivePropertyCategories;
